import React from "react";
import _ from "lodash";
import { inject } from "mobx-react";
import { NavigationTemplate } from "themes/components";

function Navigation(props) {
    return <NavigationTemplate {...props} />;
}

export default inject((i, props) => {
    const { rootStore } = i;
    const activeRoute = _.find(rootStore.routerStore.routes, {
        name: rootStore.routerStore.routerState.routeName
    });

    const queryParams = rootStore.routerStore.routerState.queryParams;
    const isNikoContext = queryParams && (queryParams.isNiko === true || queryParams.isNiko === 'true');
    const routeTitle = (isNikoContext && activeRoute.data && activeRoute.data.nikoTitle)
        ? activeRoute.data.nikoTitle
        : (activeRoute.data && activeRoute.data.title ? activeRoute.data.title : props.title);

    return {
        title: routeTitle,
        breadcrumbs: rootStore.viewStore.breadcrumbs,
        routerStore: rootStore.routerStore,
        navigationOptions: rootStore.viewStore.navigationOptions
    };
})(Navigation);
